export default __webpack_public_path__ + "static/media/icn-star-blue.ba5ca33a.svg";